export default "__VITE_ASSET__b8a97214__"